import React from "react";

const QuotationSummary = ({ quotation }) => {
  if (!quotation) return null;

  // ตรวจสอบบริษัทจาก email ผู้สร้าง (เช่น @optx)
  const isOptx = quotation.createdByUser?.toLowerCase().includes("@optx");

  return (
    <div className="bg-gray-50 dark:bg-gray-800 shadow rounded p-6 mt-6 border border-gray-100 dark:border-gray-700 transition-colors duration-300">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
        Summary
      </h2>

      <div className="flex flex-col space-y-2 text-sm text-gray-800 dark:text-gray-200 transition-colors duration-300">
        {/* Total Before Fee */}
        <p className="flex justify-between">
          <span className="font-bold text-gray-900 dark:text-gray-100">
            Total Before Fee:
          </span>
          <span>
            {quotation.totalBeforeFee?.toLocaleString("th-TH", {
              style: "currency",
              currency: "THB",
            }) || "-"}
          </span>
        </p>

        {/* Fee */}
        <p className="flex justify-between">
          <span className="font-bold text-gray-900 dark:text-gray-100">
            Fee {isOptx && `(${quotation.fee}%)`}:
          </span>
          <span>
            {quotation.calFee?.toLocaleString("th-TH", {
              style: "currency",
              currency: "THB",
            }) || "-"}
          </span>
        </p>

        {/* Total */}
        <p className="flex justify-between">
          <span className="font-bold text-gray-900 dark:text-gray-100">
            Total:
          </span>
          <span>
            {quotation.total?.toLocaleString("th-TH", {
              style: "currency",
              currency: "THB",
            }) || "-"}
          </span>
        </p>

        {/* Discount */}
        <p className="flex justify-between">
          <span className="font-bold text-gray-900 dark:text-gray-100">
            Discount:
          </span>
          <span>
            {quotation.discount?.toLocaleString("th-TH", {
              style: "currency",
              currency: "THB",
            }) || "-"}
          </span>
        </p>

        {/* Amount Before Tax */}
        <p className="flex justify-between">
          <span className="font-bold text-gray-900 dark:text-gray-100">
            Amount Before Tax:
          </span>
          <span>
            {quotation.amountBeforeTax?.toLocaleString("th-TH", {
              style: "currency",
              currency: "THB",
            }) || "-"}
          </span>
        </p>

        {/* VAT */}
        <p className="flex justify-between">
          <span className="font-bold text-gray-900 dark:text-gray-100">
            VAT (7%):
          </span>
          <span>
            {quotation.vat?.toLocaleString("th-TH", {
              style: "currency",
              currency: "THB",
            }) || "-"}
          </span>
        </p>

        {/* Net Amount */}
        <p className="flex justify-between border-t pt-2 mt-2 border-gray-200 dark:border-gray-700">
          <span className="font-bold text-gray-900 dark:text-gray-100">
            Net Amount:
          </span>
          <span className="font-semibold text-indigo-700 dark:text-indigo-300">
            {quotation.netAmount?.toLocaleString("th-TH", {
              style: "currency",
              currency: "THB",
            }) || "-"}
          </span>
        </p>
      </div>
    </div>
  );
};

export default QuotationSummary;
